import { Box, Paper, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseButton } from '../base';

interface EmptyStateProps {
  title?: ReactNode;
  description?: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  icon?: ReactNode;
}

const EmptyState = ({ title, description, actionLabel, onAction, icon }: EmptyStateProps) => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('visual.emptyState.title');
  const resolvedDescription = description ?? t('visual.emptyState.description');

  return (
    <Paper
      elevation={0}
      sx={{
        border: 'none',
        p: 4,
        textAlign: 'center',
        backgroundColor: 'transparent',
      }}
    >
      {icon && (
        <Box
          sx={theme => ({
            color: 'text.secondary',
            fontSize: theme.typography.h3.fontSize,
            mb: icon ? 1 : 0,
          })}
        >
          {icon}
        </Box>
      )}
      <Typography variant="subtitle1">{resolvedTitle}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        {resolvedDescription}
      </Typography>
      {actionLabel && onAction && (
        <BaseButton sx={{ mt: 2 }} variant="contained" onClick={onAction}>
          {actionLabel}
        </BaseButton>
      )}
    </Paper>
  );
};

export default EmptyState;
